import { render } from "./General.vue?vue&type=template&id=823108e4"
import script from "./General.vue?vue&type=script&lang=js"
export * from "./General.vue?vue&type=script&lang=js"

import "./General.vue?vue&type=style&index=0&id=823108e4&lang=css"
script.render = render

export default script